import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Tooltip,
  Chip,
  Switch,
  Alert,
  AlertTitle,
  Autocomplete,
  Snackbar,
  Backdrop,
  Container,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tabs,
  Tab,
  useMediaQuery,
  FormControlLabel,
  LinearProgress,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import WorkIcon from "@mui/icons-material/Work";
import { ControlledBoard } from "../Candidates/board";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DataTable from "../Candidates/DataTable";
import ScrapedDataTable from "../ScrapedPosts/DataTable";
import pencil_icon from "../../assets/img/pencil_icon.svg";
import { COLORS } from "colors/color";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import axios from "axios";
import {
  useLoaderData,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CandidateApplicationsList from "views/Candidates/CandidateApplicationsList";
import RecruiterCandidatesApplications from "views/Candidates/RecruiterCandidatesApplications ";
import RecruiterCandidatesApplicationsPDF from "views/Candidates/RecruiterCandidatesApplicationsPDF";
import AutoModeIcon from "@mui/icons-material/AutoMode";
import { CircularProgress } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import useUserId from "hooks/useUserId";
import { NewPostButton } from "components/Buttons/Buttons";
import WelcomSection from "views/Dashboard/WelcomSection";
import useFetchRecruiter from "hooks/useFetchRecruiter";
import { QRCodeCanvas } from "qrcode.react";
import CheckIcon from "@mui/icons-material/Check";
import { Edit, Files, Loader } from "lucide-react";
import QRCodeDialog from "./QRCodeDialog";
import { useTranslation } from "react-i18next";
import NewAppBar from "components/Navbars/AppBar";
import Navbar from "components/Navbars/nav";
import arrow_back_icon from "../../assets/img/arrow_back_icon.svg";
import { Style, UploadFile } from "@mui/icons-material";
import PublishedOffers from "./PublishedOffers";
import ArchivedPosts from "./ArchivedOffers";
import OfferDetails from "./Tabs/OfferDetails/OfferDetails";
import ImportResumes from "./imported/ImportResumes";
import ScrapedCandidate from "views/ScrapedPosts/ScrapedCandidate";
import ShareIcon from "@mui/icons-material/Share";
import { getApplicationStatusEmailTemplate } from "views/Candidates/email_templates";
import EditPostDetailsDialog from "./Dialogs/EditPostDetailsDialog";
import EditWorkingDetailsDialog from "./Dialogs/EditWorkingDetailsDialog";

const StyledTypography = styled(Typography)(() => ({
  fontFamily: "Poppins",
}));
const ToggleButton = styled(Button)(({ theme, active }) => ({
  backgroundColor: active ? COLORS.button_color : COLORS.white,
  color: active ? COLORS.white : COLORS.title_color,
  border: `1px solid ${COLORS.button_color}`,
  "&:hover": {
    backgroundColor: active ? COLORS.button_color : COLORS.Button_OnHold,
    // opacity: 0.9,
  },
  padding: "8px 16px",
  fontWeight: "bold",
  textTransform: "none",
  transition: "all 0.3s ease",
}));

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#0085FF",
  color: COLORS.white,
  // borderColor: COLORS.white,
  // border: `1px solid ${COLORS.white}`,
  "&:hover": {
    backgroundColor: "#2563eb ",
    color: "white",
    boxShadow: "0 4px 20px 0 rgba(0, 0, 0, 0.2)",
  },
  padding: "10px 20px",
  marginLeft: "2%",
  borderRadius: "30px",
  textTransform: "none",
  fontWeight: "bold",
  fontSize: "10px",
  transition: "all 0.3s ease",
  boxShadow: "0 4px 5px  rgba(0, 0, 0, 0.2)",
}));

const ProfileCard = styled(Card)(({ theme }) => ({
  height: "100%",
  display: "flex",
  flexDirection: "column",
  borderRadius: "8px",
  overflow: "hidden",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
}));

const ProfileImageWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  height: "220px",
}));
const ProfileImage = styled(CardMedia)(({ theme }) => ({
  height: "300px",
  position: "relative",
  backgroundSize: "cover",
  backgroundPosition: "center",
  transition: "all 0.4s ease",

  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "linear-gradient(135deg, rgba(0,0,0,0.1), rgba(0,0,0,0.5))",
  },
}));

const JobTitle = styled(Typography)(({ theme }) => ({
  position: "absolute",
  bottom: theme.spacing(-6),
  left: theme.spacing(2),
  right: theme.spacing(2),
  color: "white",
  fontSize: "3.5rem",
  fontWeight: 700,
  textShadow: "0 2px 4px rgba(0,0,0,0.1)",
  zIndex: 1,
}));

const DeadlineChip = styled(Chip)(({ theme }) => ({
  color: "#fff",
  position: "absolute",
  top: theme.spacing(2),
  right: theme.spacing(2),
  backgroundColor: "rgba(255, 255, 255, 0.05)",
  backdropFilter: "blur(4px)",

  // color: theme.palette.primary.main,
  fontWeight: 600,
  zIndex: 1,
}));

const CardContentWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  paddingTop: 90,
  flexDirection: "column",
  height: "100%",
  overflow: "hidden",
}));

const ScrollableContent = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  overflowY: "auto",
  padding: theme.spacing(3),
  "&::-webkit-scrollbar": {
    width: "8px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#f1f1f1",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#c1c1c1",
    borderRadius: "4px",
    "&:hover": {
      backgroundColor: "#a8a8a8",
    },
  },
}));
const RequirementChip = styled(Chip)(({ theme }) => ({
  margin: theme.spacing(0.5),
  backgroundColor: `${COLORS.button_color}80`,
  color: "white",
  "& .MuiChip-icon": {
    color: "#fff",
  },
}));

const PostDetails = () =>
// { post, onBack, apiUrl }
{
  const { formData, loading, error } = useFetchRecruiter();
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiUrlFront = process.env.REACT_APP_API_FRONT_URL;
  // const post = useLoaderData();
  // const { id } = useParams();
  const { id } = useParams();
  const decodedId = atob(id);
  const [data, setData] = useState([]);
  const [applications, setApplications] = useState([]);
  const [applicationsImported, setApplicationsImported] = useState([]);
  const navigate = useNavigate();
  const [viewMode, setViewMode] = useState("candidates");
  const { t } = useTranslation();
  const [steps, setSteps] = useState([]);
  const [stepId, setStepId] = useState();
  const [userRole, setUserRole] = useState(getUserRoleFromAccessToken());
  const userId = getUserIdFromAccessToken();
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [code, setCode] = useState("");
  const [isScrappingLaunched, setIsScrappingLaunched] = useState(false);
  const [state, statechange] = useState(false);
  const [finishing, setfinishing] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [post, setPost] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showQRCodeDialog, setShowQRCodeDialog] = useState(false);
  const [urlCopied, setUrlCopied] = useState(false);
  const [qrCodeUrl, setQRCodeUrl] = useState("");
  const [shouldRefreshApplications, setShouldRefreshApplications] = useState(false);
  const [showImportProgress, setShowImportProgress] = useState(false); // Add this state
  const [importProgress, setImportProgress] = useState(0); // Add this state
  const [importFileCount, setImportFileCount] = useState(0); // Track file count
  const [estimatedTimeRemaining, setEstimatedTimeRemaining] = useState(0); // Track remaining time
  const [filterDialogOpen, setFilterDialogOpen] = useState(false);
  const [filterOptions, setFilterOptions] = useState({ quiz: false });
  const isSmallScreen = useMediaQuery("(max-width: 600px)");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  // const userRole= useUserId().;
  const getPost = async () => {
    try {
      const response = await axios.get(`${apiUrl}posts/${decodedId}/find`);
      setPost(response.data);
      console.log('my post:', response.data)
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching job data:", error);
      setIsLoading(false);
      // Handle error (e.g., show error message to user)
    }
  };
  useEffect(() => {
    getPost();
  }, []);

  // Initialize edit states when post data is loaded
  useEffect(() => {
    if (post && post.id) {
      setPostTitle(post.title || "");
      setPostDescription(post.description || "");
      setPostRequirement(post.requirements || []);
      setPostDeadline(post.deadline || "");
      setOfferType(post.offerType === "i" ? "internship" : "job");
      setReference(post.reference || "");
      setAccountType(post.accountType || "");
      setRecruiterEmail(post.recruiter_email || "");
      setWorkingMode(post.mode || "Remote");
      setLocation(post.localisation || "");
      setNumPeople(post.age_experience || "");
      setSalary(post.salary || "");
      setCurrency(post.currency || "MAD");
      setExperience(post.experiences || "");
      setDiploma(post.highest_diploma || "");
      setFieldOfStudy(post.field_of_study || "");
      setPostImage(post.image || "");
    }
  }, [post]);
  const handleImportSuccess = (fileCount = 1) => {
    setShouldRefreshApplications(true);

    // Show the progress bar
    setShowImportProgress(true);
    setImportProgress(0);
    setImportFileCount(fileCount);

    // Calculate dynamic duration: fileCount * 20 seconds
    const totalDuration = fileCount * 20; // seconds
    const progressIncrement = 100 / totalDuration; // percentage per second
    setEstimatedTimeRemaining(totalDuration);

    let elapsedTime = 0;

    // Simulate progress over dynamic duration
    const interval = setInterval(() => {
      elapsedTime += 1;
      setEstimatedTimeRemaining(totalDuration - elapsedTime);

      setImportProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          // Call Load_applications when progress is complete
          Load_applications();
          // Hide progress bar after completion
          setTimeout(() => {
            setShowImportProgress(false);
            setEstimatedTimeRemaining(0);
          }, 500);
          return 100;
        }
        return prev + progressIncrement; // Dynamic increment based on file count
      });
    }, 1000); // Update every second
  };
  useEffect(() => {
    Load_applications_imported();

    // Reset the flag after loading
    if (shouldRefreshApplications) {
      setShouldRefreshApplications(false);
    }
  }, [shouldRefreshApplications]);
  // useEffect(() => {
  //   console.log("post:", id);
  // }, [post]);
  function getUserRoleFromAccessToken() {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      console.error("No access token found in local storage");
      return null;
    }
  }

  function getUserRoleFromAccessToken() {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      console.error("No access token found in local storage");
      return null;
    }

    try {
      const decodedToken = parseJwt(accessToken);
      //console.log("Access token : ", decodedToken);
      const userRole = decodedToken.role;
      return userRole;
    } catch (error) {
      console.error("Failed to decode access token", error);
      return null;
    }
  }
  function getUserIdFromAccessToken() {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      console.error("No access token found in local storage");
      return null;
    }

    try {
      const decodedToken = parseJwt(accessToken);
      //console.log("Access token : ", decodedToken);
      const userId = decodedToken.user_id;
      return userId;
    } catch (error) {
      console.error("Failed to decode access token", error);
      return null;
    }
  }
  function parseJwt(token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    //console.log("payload : ", jsonPayload);

    return JSON.parse(jsonPayload);
  }

  const [fullStepData, setFullStepData] = useState([]);

  useEffect(() => {
    if (userRole !== "r") {
      console.log("User is not a recruiter. Navigating to home.");
      navigate("/home");
    }
  }, [userRole, navigate]);

  useEffect(() => {
    Load_applications();
  }, [post]);



  useEffect(() => {
    console.log("post Details ");
  }, []);

  useEffect(() => {
    const fetchSteps = async () => {
      console.log("UserId :", userId);
      console.log("post id :", post.id);
      try {
        const response = await fetch(
          `${apiUrl}recruiters/steps/?post=${post.id}`,
          {
            method: "GET",
            headers: {
              "Content-type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("accessToken"),
            },
          }
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();

        if (Array.isArray(data)) {
          const stepTitles = data.map((step) => step.step);
          setSteps(stepTitles);

          const fullStepData = data.map((step) => ({
            id: step.id,
            title: step.step,
          }));
          setFullStepData(fullStepData);

          console.log("Step titles:", stepTitles);
          console.log("Full step data:", fullStepData);
        } else {
          console.error("Fetched data is not an array:", data);
        }
      } catch (error) {
        console.error("Error fetching steps:", error);
      }
    };
    fetchSteps();
  }, [apiUrl, userId]);

  const deleteSteps = async (stepTitle) => {
    if (!stepTitle) return; // Don't do anything if stepTitle is null or undefined

    console.log("Deleting step:", stepTitle);

    const stepToDelete = fullStepData.find(
      (step) => step.title === stepTitle
    );
    if (stepToDelete) {
      try {
        const response = await fetch(
          `${apiUrl}recruiters/steps/${stepToDelete.id}/delete/?recruiter=${userId}`,
          {
            method: "DELETE",
            headers: {
              "Content-type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("accessToken"),
            },
          }
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log("Step deleted:", data);

        // Update steps after deletion
        setSteps((prevSteps) =>
          prevSteps.filter((step) => step !== stepTitle)
        );

        // Update fullStepData after deletion
        setFullStepData((prevData) =>
          prevData.filter((step) => step.title !== stepTitle)
        );
      } catch (error) {
        console.error("Error deleting step:", error);
      }
    } else {
      console.error("Step not found for deletion:", stepTitle);
    }
  };
  useEffect(() => {
    console.log("post id :", post.id);
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get("code");
    if (code && window.opener) {
      window.opener.postMessage({ code: code }, window.location.origin);
      window.close();
    }
  }, []);
  const createStep = (stepName) => {
    const addSteps = async () => {
      try {
        const response = await axios.post(
          `${apiUrl}recruiters/steps/create/`,
          {
            step: stepName,
            post: post.id,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken"),
            },
          }
        );

        console.log("Step added successfully:", response.data);

        // Update steps and fullStepData only if the step was successfully added to the database
        if (response.data && response.data.id) {
          setSteps((prevSteps) => {
            // Check if the step already exists to prevent duplication
            if (!prevSteps.includes(stepName)) {
              return [...prevSteps, stepName];
            }
            return prevSteps;
          });

          setFullStepData((prevData) => {
            // Check if the step already exists to prevent duplication
            if (!prevData.some((step) => step.title === stepName)) {
              return [...prevData, { id: response.data.id, title: stepName }];
            }
            return prevData;
          });
        }
      } catch (error) {
        if (error.response) {
          console.error("Error adding step:", error.response.data);
        } else {
          console.error("Error adding step:", error.message);
        }
      }
    };
    addSteps();
  };

  const Scrapping = async () => {
    try {
      // Start the scraping process
      console.log("here is the post id: ", post.id);
      const response = await fetch(
        `${apiUrl}ai/start_scraping_post/${post.id}/`,

        {
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        }
      );

      if (response.status === 401) {
        console.log("Unauthorized. Redirecting to login page...");
        navigate("/login");
        return;
      }

      const result = await response.json();
      console.log("Scraping task initiated: ", result);

      if (result.state) {
        // Task was successfully added to the queue, now start polling for status
        pollScrapingStatus(1);
        // pollScrapingStatus(id);
      } else {
        console.error("Failed to start scraping: ", result.message);
      }
    } catch (error) {
      console.error("Error initiating scraping:", error);
    }
  };
  const pollScrapingStatus = async (id) => {
    try {
      console.log("before the 30s");
      await new Promise((resolve) => setTimeout(resolve, 30000));
      console.log("after the 30s");
      const intervalId = setInterval(async () => {
        const response = await fetch(
          `${apiUrl}ai/get_scraping_status/${post.id}/`,
          {
            headers: {
              "Content-type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("accessToken"),
            },
          }
        );

        const result = await response.json();
        console.log("Polling result: ", result);

        if (result.state !== "pending") {
          clearInterval(intervalId);
          setIsScrappingLaunched(false);
          statechange(false);
          setfinishing(true);

          if (result.state) {
            console.log("Scraping succeeded: ", result.message);
          } else {
            console.error("Scraping failed: ", result.message);
          }
        }
      }, 5000); // Poll every 5 seconds
    } catch (error) {
      console.error("Error polling scraping status:", error);
    }
  };
  const code_outlook = async () => {
    try {
      const response = await fetch(`${apiUrl}ai/code_outlook/${post.id}/`);
      const result = await response.json();
      console.log("code : ", result.user_code);
      setCode(result.user_code);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  function openAuthPopup() {
    const authUrl =
      "https://login.microsoftonline.com/common/oauth2/deviceauth";
    const width = window.screen.width / 3;
    const height = window.screen.height;
    const left = window.screen.width - width;
    const top = 0;

    window.open(
      authUrl,
      "authPopup",
      `width=${width},height=${height},top=${top},left=${left}`
    );
  }
  const hidde_finishing = () => {
    setfinishing(false);
    // setInternDetails(false);
    statechange(false);
    setIsScrappingLaunched(false);
    // Load();
  };
  const handleCopy = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(code)
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        })
        .catch(() => {
          setSnackbarOpen(true);
        });
    } else {
      setSnackbarOpen(true);
    }
  };
  async function Load_applications_imported() {
    try {
      let url = `${apiUrl}authentication/candidates-scraped-for-post/${post.id}/`;
      if (filterOptions.quiz) {
        url += `?quiz=true`;
      }
      const response = await fetch(url, {
        headers: {
          "Content-type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      });
      if (response.status === 401) {
        return;
      }
      const json = await response.json();
      setApplicationsImported(json);
      console.log("applications imported : ", json);
    } catch (error) {
      console.error("Error loading applications:", error);
    }
  }
  async function Load_applications() {
    try {
      let url = `${apiUrl}candidates/applications/by-post/${post.id}/`;
      if (filterOptions.quiz) {
        url += `?quiz=true`;
      }
      const response = await fetch(url, {
        headers: {
          "Content-type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      });
      if (response.status === 401) {
        return;
      }
      const json = await response.json();
      setApplications(json);
    } catch (error) {
      console.error("Error loading applications:", error);
    }
  }
  const handleSendEmail = async (emailData) => {
    try {
      // Destructure email data

      const { userId: userId, to: receiver, subject, applicant_name, status, job_title, job_link, application_date } = emailData;

      // Prepare payload for backend
      const payload = {
        user_id: userId,
        to: receiver,
        subject,
        applicant_name,
        status,
        job_title,
        job_link,
        application_date,
      };
      console.log("here is the send data", payload);

      // Send email using backend API
      const response = await axios.post(
        `${apiUrl}authentication/api/send-email/`,
        payload
      );

      // Handle successful email sending
      console.log("Email sent successfully!");
      return response.data;
    } catch (error) {
      // Handle any errors in email sending
      console.error("Email sending failed:", error);
      alert(error.response?.data?.detail || "Failed to send email");
      throw error;
    }
  };
  const updateApplicationStep = async (applicationId, newStep, status, description) => {


    try {
      const url = status !== "Application-Imported" && status !== "Scraping-Email" && status !== "Application Spontane"
        ? `${apiUrl}authentication/applications/${applicationId}/update-step/`
        : `${apiUrl}authentication/applicationsscraped/${applicationId}/update-step/`;

      console.log("updatedApplicationsw : ", applicationId, newStep, " status : ", status, " Link : ", url);
      const response = await axios.patch(
        url,
        { step: newStep },
        {
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        }
      );

      if (response.status === 200) {
        // Send email notification about step update
        const emailData = {
          userId: userId,
          to: description, // Assuming post has an email field for notifications
          applicant_name: "Dear Applicant",
          status: newStep,
          job_title: post.title,
          job_link: `${apiUrlFront}viewjob/${btoa(post.id)}`,
          application_date: new Date().toLocaleString(),
          subject: `Application Status Update -  ${newStep}`,

        };
        console.log("Email data to be sent:", emailData);
        // await handleSendEmail(emailData);

        const updatedApplications = applications.map((app) =>
          app.id === applicationId ? { ...app, step: newStep } : app
        );
        setApplications(updatedApplications);
        console.log("updatedApplications : ", updatedApplications);
      }
    } catch (error) {
      console.error("Error updating application step:", error);
    }
  };

  const visualizePost = () => {
    console.log("visualizePost clicked!!");
    const encodedId = btoa(post.id); // Encode the ID
    navigate(`/viewjob/${encodedId}`);
  };

  const copyViewJobUrl = () => {
    const encodedId = btoa(post.id); // Encode the ID
    const url = `${window.location.origin}/viewjob/${encodedId}`;

    // Copy to clipboard
    navigator.clipboard.writeText(url).then(() => {
      // Set the URL for QR code and open dialog
      setQRCodeUrl(url);
      setShowQRCodeDialog(true);
    });
  };

  const handleCloseQRCodeDialog = () => {
    setShowQRCodeDialog(false);
  };
  const handleCopyUrl = () => {
    navigator.clipboard.writeText(qrCodeUrl).then(() => {
      setUrlCopied(true);
      setTimeout(() => setUrlCopied(false), 2000);
    });
  };
  const handleDownloadQRCode = () => {
    const canvas = document.getElementById("job-qr-code");
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = `job-${post.id}-qr.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  useEffect(() => {
    let timer;
    if (state) {
      timer = setTimeout(() => {
        setShowLoading(true);
      }, 5000);
    } else {
      setShowLoading(false);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [state]);
  useEffect(() => {
    if (finishing) {
      setOpenSnackbar(true);
    }
  }, [finishing]);

  const [importDialogOpen, setImportDialogOpen] = useState(false);

  // Edit dialog states
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editWorkingDialogOpen, setEditWorkingDialogOpen] = useState(false);
  const [postTitle, setPostTitle] = useState("");
  const [postDescription, setPostDescription] = useState("");
  const [postRequirement, setPostRequirement] = useState([]);
  const [postDeadline, setPostDeadline] = useState("");
  const [offerType, setOfferType] = useState("job");
  const [errors, setErrors] = useState({});
  const [dateError, setDateError] = useState("");
  const [reference, setReference] = useState("");
  const [accountType, setAccountType] = useState("");
  const [recruiterEmail, setRecruiterEmail] = useState("");

  // Working details states
  const [workingMode, setWorkingMode] = useState("Remote");
  const [location, setLocation] = useState("");
  const [numPeople, setNumPeople] = useState("");
  const [salary, setSalary] = useState("");
  const [currency, setCurrency] = useState("MAD");
  const [isChecked, setIsChecked] = useState(false);
  const [isCheckedScr, setIsCheckedScr] = useState(false);
  const [experience, setExperience] = useState("");
  const [diploma, setDiploma] = useState("");
  const [otherDiploma, setOtherDiploma] = useState("");
  const [fieldOfStudy, setFieldOfStudy] = useState("");
  const [otherFieldOfStudy, setOtherFieldOfStudy] = useState("");
  const [postImage, setPostImage] = useState("");

  const handleOpenImportDialog = () => {
    setImportDialogOpen(true);
  };

  const handleCloseImportDialog = () => {
    setImportDialogOpen(false);
  };

  // Edit dialog handlers
  const handleEditClick = () => {
    setEditDialogOpen(true);
  };

  const handleDateChange = (newDate) => {
    setPostDeadline(newDate);
    setDateError("");
  };

  const handleNext = () => {
    // Validate form
    const newErrors = {};

    if (!postTitle.trim()) {
      newErrors.postTitle = t("errors.requiredField");
    }

    if (!postDescription.trim()) {
      newErrors.postDescription = t("errors.requiredField");
    }

    if (!offerType) {
      newErrors.offerType = t("errors.requiredField");
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // Move to second dialog
    setEditDialogOpen(false);
    setEditWorkingDialogOpen(true);
  };
  const stripHtmlTags = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  };


  const handleSave = async (secondDialogData) => {
    try {
      // Format the data to match API expectations
      const completeUpdateData = {
        postId: post.id,
        title: postTitle,
        description: postDescription,
        experiences: stripHtmlTags(postDescription),
        requirements: postRequirement,
        deadline: postDeadline,
        reference: reference || null,
        mode: secondDialogData.mode,
        localisation: secondDialogData.localisation,
        age_experience: secondDialogData.age_experience || null,
        salary: secondDialogData.salary !== "" ? secondDialogData.salary : null,
        offerType: offerType === "internship" ? "i" : "j",
        image: secondDialogData.image,
        field_of_study: secondDialogData.field_of_study,
        highest_diploma: secondDialogData.highest_diploma,
        currency: secondDialogData.currency || currency
      };

      console.log("Sending update with data1:", completeUpdateData);

      // Call API to update post
      const response = await axios.put(`${apiUrl}posts/${post.id}/update/`, completeUpdateData, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      });

      if (response.status === 200) {
        // Update local post state
        setPost(prev => ({
          ...prev,
          ...completeUpdateData,
          offerType: offerType === "internship" ? "i" : "j"
        }));

        // Close dialog
        setEditWorkingDialogOpen(false);

        // Show success message
        console.log("Post updated successfully");
      }
    } catch (error) {
      console.error("Error updating post:", error);
    }
  };

  const handleImageUpload = (image) => {
    setPostImage(image);
    setErrors((prev) => ({ ...prev, postImage: "" }));
  };

  const handleSalaryChange = (value) => {
    setSalary(value);
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleCheckboxChangeScr = (event) => {
    setIsCheckedScr(event.target.checked);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };
  const [tableType, setTableType] = useState("Offer_details");
  useEffect(() => {
    Load_applications_imported();
  }, [post]);
  useEffect(() => {
    if (tableType === "Candidates-Imported") {
      Load_applications_imported();
    }
  }, [tableType]);

  useEffect(() => {
    if (tableType === "Candidates" || tableType === "Steps_board") {
      Load_applications();
    }
  }, [tableType, filterOptions.quiz]);

  useEffect(() => {
    if (tableType === "Candidates-Imported") {
      Load_applications_imported();
    }
  }, [tableType, filterOptions.quiz]);

  const handleTableTypeChange = (event, newValue) => {
    setTableType(newValue);
    setTabPage(0);
  };
  const CandidateViewToggle = ({ displayMode, setDisplayMode }) => {
    const handleChange = (newMode) => {
      setDisplayMode(newMode);
    };

    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', mb: 2 }}>
        <Box sx={{
          display: 'inline-flex',
          borderRadius: 1,
          overflow: 'hidden',
          fontSize: '1rem',
          fontWeight: 'medium',

        }}>
          <Button variant="contained"
            onClick={() => handleChange('table')}
            sx={{
              backgroundColor: displayMode === 'table' ? 'black' : 'white',
              color: displayMode === 'table' ? 'white' : 'black',
              border: '1px solid black',
              '&:hover': {
                backgroundColor: displayMode === 'table' ? 'black' : 'white',

              },
              mr: 0.5,
            }}
          >
            Candidates
          </Button>
          <Button

            onClick={() => handleChange('scraped')}
            sx={{
              backgroundColor: displayMode === 'scraped' ? 'black' : 'white',
              color: displayMode === 'scraped' ? 'white' : 'black',
              '&:hover': {
                backgroundColor: displayMode === 'scraped' ? 'black' : 'grey.50',

              },
              border: '1px solid black',
            }}
          >
            Imported Candidates
          </Button>
        </Box>
      </Box>
    );
  };


  const [tabPage, setTabPage] = useState(0);
  const [displayMode, setDisplayMode] = useState("table"); // "table" or "scraped"


  const renderTable = () => {
    switch (tableType) {
      case "Offer_details":
        return <OfferDetails post={post} />;
      case "Candidates":


        return (
          <>
            <DataTable
              candidates={applications}
              knob={true}
              steps={steps}
              post_id={post.id}
              onCandidatesUpdate={Load_applications}
              filterOptions={filterOptions}
              setFilterOptions={setFilterOptions}
              onFilterApply={() => {
                // Data will be reloaded via useEffect dependency on filterOptions.quiz
              }}
            />
            {/* Use the improved toggle component */}
            {/* <CandidateViewToggle
              displayMode={displayMode}
              setDisplayMode={setDisplayMode}

            /> */}

            {/* Conditional Rendering based on display mode */}
            {/* {displayMode === "table" ? (
              <DataTable candidates={applications} knob={true} />
            ) : (
              <ScrapedCandidate
                // View state
                viewMode={viewMode}
                setViewMode={setViewMode}
                // Data
                applications={applicationsImported}
                post={post}
                // Components
                ToggleButton={ToggleButton}
                DataTable={ScrapedDataTable}
                ControlledBoard={ControlledBoard}
                // Board functionality
                updateApplicationStep={updateApplicationStep}
                deleteSteps={deleteSteps}
                setSteps={setSteps}
                setStepId={setStepId}
                createStep={createStep}
                steps={steps}
              />
            )} */}
          </>
        );

      case "Candidates-Imported":
        return (
          <ScrapedCandidate
            // View state
            viewMode={viewMode}
            setViewMode={setViewMode}
            // Data
            applications={applicationsImported}
            post={post}
            // Components
            ToggleButton={ToggleButton}
            DataTable={ScrapedDataTable}
            ControlledBoard={ControlledBoard}
            // Board functionality
            updateApplicationStep={updateApplicationStep}
            deleteSteps={deleteSteps}
            setSteps={setSteps}
            setStepId={setStepId}
            createStep={createStep}
            steps={steps}
            filterOptions={filterOptions}
            setFilterOptions={setFilterOptions}
            onFilterApply={() => {
              // Data will be reloaded via useEffect dependency on filterOptions.quiz
            }}
          />
        );
      case "Steps_board":
        return (
          <ControlledBoard
            candidates={applications}
            onUpdateStep={updateApplicationStep}
            deleteSteps={deleteSteps}
            setSteps={setSteps}
            setStepId={setStepId}
            createStep={createStep}
            steps={steps}
            post={post}
          />
        );
      default:
        return <PublishedOffers />;
    }
  };
  if (!post) {
    return (
      <Box p={3}>
        <Alert severity="error">
          <AlertTitle>{t('postDetails.error.title')}</AlertTitle>
          {t('postDetails.error.loadFailed')}
        </Alert>
      </Box>
    );
  }

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{ backgroundColor: "#F4F5F7", width: "100%", px: 0, height: "100%" }}
    >


      <Box
        mt={3}
        mb={3}
        sx={{
          paddingLeft: { xs: 2, sm: 4 },
          paddingRight: { xs: 2, sm: 4 },
          marginBottom: 6,
        }}
      >
        <Grid container spacing={2}>
          {/* Back to Posts Button */}
          <Grid item xs={3} sm="auto">
            <NewPostButton
              sx={{
                gap: 1,
                width: "100%",
                justifyContent: { xs: "center", sm: "flex-start" },
                "&:hover img": {
                  filter: "brightness(0) invert(1)",
                  transition: "filter 0.3s ease",
                },
              }}
              onClick={() => {
                if (post.archived) {
                  navigate("/talent/post/PostDetails", { state: { archived: true } });
                } else {
                  navigate("/talent/post/PostDetails", { state: { archived: false } });
                }
              }}
            >
              {isSmallScreen ? (
                <img
                  src={arrow_back_icon}
                  style={{
                    transition: "all 0.3s ease",
                  }}
                />
              ) : (
                <>
                  <img
                    src={arrow_back_icon}
                    style={{
                      transition: "all 0.3s ease",
                    }}
                  />
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontWeight: 400,
                      fontSize: "14px",
                    }}
                  >
                    {t("back_to_posts")}
                  </Typography>
                </>
              )}
            </NewPostButton>
          </Grid>

          {/* Visualize Post Button */}
          <Grid item xs={3} sm="auto">
            <NewPostButton
              sx={{
                gap: 1,
                width: "100%",
                justifyContent: { xs: "center", sm: "flex-start" },
                "&:hover .MuiSvgIcon-root": {
                  color: "white",
                  transition: "color 0.3s ease",
                },
              }}
              onClick={visualizePost}
            >
              {isSmallScreen ? (
                <VisibilityIcon />
              ) : (
                <>
                  <VisibilityIcon />
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontWeight: 400,
                      fontSize: "14px",
                    }}
                  >
                    {t("visualize_post")}
                  </Typography>
                </>
              )}
            </NewPostButton>
          </Grid>
          <Grid item xs={3} sm="auto">
            <NewPostButton
              sx={{
                gap: 1,
                width: "100%",
                justifyContent: { xs: "center", sm: "flex-start" },
                "&:hover .MuiSvgIcon-root": {
                  color: "white",
                  transition: "color 0.3s ease",
                },
              }}
              onClick={handleEditClick}
            >
              {isSmallScreen ? (
                <img
                  src={pencil_icon}
                  style={{
                    width: isMobile ? 14 : 14,
                    height: isMobile ? 14 : 14,
                    // background: red,
                  }}
                />
              ) : (
                <>

                  {/* If it's a custom SVG or other library: */}
                  <Edit width="16" height="16" />
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontWeight: 400,
                      fontSize: "14px",
                    }}
                  >
                    Modifier L'offre
                  </Typography>
                </>
              )}
            </NewPostButton>
          </Grid>
          <Grid item xs={3} sm="auto">
            <NewPostButton
              sx={{
                gap: 1,
                width: "100%",
                justifyContent: { xs: "center", sm: "flex-start" },
                "&:hover .MuiSvgIcon-root": {
                  color: "white",
                  transition: "color 0.3s ease",
                },
              }}
              onClick={copyViewJobUrl}
            >
              {isSmallScreen ? (
                <ShareIcon />
              ) : (
                <>
                  <ShareIcon
                    sx={{
                      fontSize: "10px",
                      height: 10,
                      width: 10,
                    }}
                  />
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontWeight: 400,
                      fontSize: "14px",
                    }}
                  >
                    {t("share")}
                  </Typography>
                </>
              )}
            </NewPostButton>
          </Grid>

          {/* Import Resumes Button */}
          <Grid item xs={3} sm="auto">
            <NewPostButton
              sx={{
                gap: 1,
                width: "100%",
                justifyContent: { xs: "center", sm: "flex-start" },
                "&:hover .MuiSvgIcon-root": {
                  color: "white",
                  transition: "color 0.3s ease",
                },
              }}
              onClick={handleOpenImportDialog}
            >
              {isSmallScreen ? (
                <UploadFile />
              ) : (
                <>
                  <UploadFile />
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontWeight: 400,
                      fontSize: "14px",
                    }}
                  >
                    {t('postDetails.importResumes')}
                  </Typography>
                </>
              )}
            </NewPostButton>
          </Grid>

          {/* Share Button */}


        </Grid>

        <ImportResumes
          open={importDialogOpen}
          onClose={handleCloseImportDialog}
          postID={post.id}
          onImportSuccess={handleImportSuccess}

        />
      </Box>

      <QRCodeDialog
        open={showQRCodeDialog}
        onClose={handleCloseQRCodeDialog}
        qrCodeUrl={qrCodeUrl}
        formData={post}
        callerComponent="PostDetails"
      />

      <Box sx={{ position: "relative", marginLeft: 5, marginBottom: 4 }}>
        {/* Static gray line */}
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "2.5px",
            backgroundColor: "divider",
            zIndex: 0,
          }}
        />

        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Tabs
            value={tableType}
            onChange={handleTableTypeChange}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              flexGrow: 1,
              "& .MuiTabs-indicator": {
                height: "2px",
                zIndex: 1,
              },
              "& .MuiTab-root": {
                fontFamily: "Poppins",
                fontWeight: 500,
                fontSize: "14px",
              },
            }}
          >
            <Tab
              label={t('postDetails.offerDetails')}
              sx={{ fontFamily: "Poppins", textTransform: "none" }}
              value="Offer_details"
            />
            <Tab
              label={t('postDetails.candidates')}
              sx={{ fontFamily: "Poppins", textTransform: "none" }}
              value="Candidates"
            />
            <Tab
              label={t('postDetails.stepsBoard')}
              sx={{ fontFamily: "Poppins", textTransform: "none" }}
              value="Steps_board"
            />
          </Tabs>
        </Box>
      </Box>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          {/* Import Progress Bar */}
          {showImportProgress && (
            <Box sx={{ width: '100%', mb: 3, maxWidth: '600px', margin: '0 auto' }}>
              <Typography sx={{ mb: 1, fontFamily: 'Poppins', textTransform: 'none' }}>
                {t('Processing imported data...')} ({importFileCount} {importFileCount === 1 ? 'file' : 'files'})
              </Typography>
              <LinearProgress
                variant="determinate"
                value={importProgress}
                sx={{
                  height: 8,
                  borderRadius: 4,
                  '& .MuiLinearProgress-bar': {
                    backgroundColor: '#0017E7'
                  }
                }}
              />
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                <Typography variant="body2" sx={{ fontFamily: 'Poppins' }}>
                  {Math.round(importProgress)}% Complete
                </Typography>
                <Typography variant="body2" sx={{ fontFamily: 'Poppins', color: 'text.secondary' }}>
                  {estimatedTimeRemaining > 0 ? `~${Math.ceil(estimatedTimeRemaining)}s remaining` : 'Finalizing...'}
                </Typography>
              </Box>
            </Box>
          )}
          {renderTable()}
        </>
      )}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{
            width: "100%",
            "& .MuiAlert-message": {
              fontSize: "1rem",
            },
          }}
        >
          <AlertTitle>{t("success")}</AlertTitle>
          {t("operation_success")}
        </Alert>
      </Snackbar>

      {/* Edit Dialogs */}
      <EditPostDetailsDialog
        setOpen={setEditDialogOpen}
        postTitle={postTitle}
        setPostTitle={setPostTitle}
        postDescription={postDescription}
        setPostDescription={setPostDescription}
        offerType={offerType}
        setOfferType={setOfferType}
        postRequirement={postRequirement}
        setPostRequirement={setPostRequirement}
        postDeadline={postDeadline}
        handleDateChange={handleDateChange}
        handleNext={handleNext}
        open={editDialogOpen}
        errors={errors}
        dateError={dateError}
        setDateError={setDateError}
        showRef={post.scraped}
        accountType={accountType}
        setAccountType={setAccountType}
        reference={reference}
        setReference={setReference}
        recruiterEmail={recruiterEmail}
        setRecruiterEmail={setRecruiterEmail}
        setErrors={setErrors}
      />

      <EditWorkingDetailsDialog
        setOpen2={setEditWorkingDialogOpen}
        setOpen={setEditDialogOpen}
        open2={editWorkingDialogOpen}
        errors={errors}
        handleImageUpload={handleImageUpload}
        setWorkingMode={setWorkingMode}
        workingMode={workingMode}
        location={location}
        setLocation={setLocation}
        setErrors={setErrors}
        numPeople={numPeople}
        setNumPeople={setNumPeople}
        salary={salary}
        handleSalaryChange={handleSalaryChange}
        currency={currency}
        setCurrency={setCurrency}
        isChecked={isChecked}
        handleCheckboxChange={handleCheckboxChange}
        isCheckedScr={isCheckedScr}
        handleCheckboxChangeScr={handleCheckboxChangeScr}
        handleSave={handleSave}
        experience={experience}
        setExperience={setExperience}
        diploma={diploma}
        setDiploma={setDiploma}
        otherDiploma={otherDiploma}
        setOtherDiploma={setOtherDiploma}
        fieldOfStudy={fieldOfStudy}
        setFieldOfStudy={setFieldOfStudy}
        otherFieldOfStudy={otherFieldOfStudy}
        setOtherFieldOfStudy={setOtherFieldOfStudy}
        job={post}
        postTitle={postTitle}
      />
    </Container>
  );
};

export default PostDetails;
